import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ServerRoutes } from "../ServerRoutes";
import { Router } from "@angular/router";

@Injectable({
	providedIn: "root",
})

export class UserService {
	constructor(
		private http: HttpClient,
		private routes: ServerRoutes,
		private router: Router
	) {}

	getHoraServidor() {
		return this.http.get(this.routes.horaServidor);
	}

	setUser(user) {
		localStorage.setItem("user", JSON.stringify(user));
	}

	getUser() {
		try {
			return JSON.parse(localStorage.getItem("user"));
		} catch (e) {
			localStorage.clear();
			return false;
		}
	}

	getHeader() {
		let header = {
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				token: this.getToken(),
			}),
		};
		return header;
	}

	getToken() {
		if (localStorage.getItem("user")) {
			return JSON.parse(localStorage.getItem("user")).token;
		}
	}

	getName() {
		return JSON.parse(localStorage.getItem("user")).name;
	}

	getId() {
		return JSON.parse(localStorage.getItem("user")).id;
	}

	getPerfil() {
		return this.routes.requisicaoHTTP(
			this.http.get(this.routes.getPerfil(this.getId()), this.getHeader())
		);
	}

	getPerfilHasAgenda() {
		return this.routes.requisicaoHTTP(
			this.http.get(this.routes.getPerfilHasAgenda(this.getId()), this.getHeader())
		);
	}

	editPerfil(perfil) {
		return this.routes.requisicaoHTTP(
			this.http.post(this.routes.editPerfil, perfil, this.getHeader())
		);
	}

	editPerfilDadosPessoais (dados) {
		return this.routes.requisicaoHTTP(
			this.http.post(this.routes.editPerfilDados, dados, this.getHeader())
		);
	}

	editSenhaDadosPessoais (dados) {
		return this.routes.requisicaoHTTP(
			this.http.post(this.routes.editSenhaDados, dados, this.getHeader())
		);
	}

	editPerfilEndereco (dados) {
		return this.routes.requisicaoHTTP(
			this.http.post(this.routes.editPerfilEndereco, dados, this.getHeader())
		);
	}

	setBancario(bancario) {
		return this.http.post(
			this.routes.setBancario,
			bancario,
			this.getHeader()
		);
	}

	updateBancario(bancario) {
		return this.http.post(
			this.routes.updateBancario,
			bancario,
			this.getHeader()
		);
	}

	uploadImage(image) {
		return this.http.post(this.routes.uploadImage, image, this.getHeader());
	}

	clear() {
		localStorage.clear();
		this.router.navigate(["/"]);
	}

	enviarCodigoRefazerSenha(dados) {
		return this.http.post(this.routes.enviarCodigoSenha, dados);
	}

	atualizarSenha(dados) {
		return this.http.post(this.routes.atualizarSenha, dados);
	}

	lgpd() {
		const userId = JSON.parse(localStorage.getItem("user")).id;
		return this.routes.requisicaoHTTP(
			this.http.get(this.routes.getLgpd(userId), this.getHeader())
		);
	}

	confirmLgpd() {
		const userId = JSON.parse(localStorage.getItem("user")).id;
		return this.routes.requisicaoHTTP(
			this.http.get(this.routes.setLgpd(userId), this.getHeader())
		);
	}
}
